import React, { useState, useEffect, useCallback, useContext } from 'react';
import { Card, Form, Button, Badge, Alert, Spinner, Row, Col, ListGroup, Accordion, AccordionItem } from 'react-bootstrap';
import SearchableDropdown from '../../../../components/common/SearchableDropdown';
import { deleteAPI, getAPI, postAPI, putAPI } from '../../../../apis/backend/apiNode';
import showNotification from '../../../../components/extras/showNotification';
import Icon from '../../../../components/icon/Icon';
import AuthContext from '../../../../contexts/authContext';
import { useNavigate } from 'react-router-dom'; // ADD THIS IMPORT
import { searchPythonAPI } from 'apis/backend/apiPython';
import { formatCurrency } from 'pages/comptabilite/utils/functions';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import RelanceFactureManager from 'pages/comptabilite/Clients/RelanceFactureManager';


const ChronologieTab = ({
  intervention,
  CHRONOLOGIE_TYPES,
  onAddChronologieEntry,
  getChronologieByIntervention,
  userData,
  onHide,
  getUserDisplayName
}) => {
  const [chronologieData, setChronologieData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { t } = useTranslation('translation_invoice');

  // Form State
  const [newEntry, setNewEntry] = useState({
    type: CHRONOLOGIE_TYPES.NOTE || 'note',
    note: '',
    devisId: '',
    facture: '',
    demandePrixId: '',
    bonCommandeId: '',
    piecesJointes: [],
  });

  // Selection States
  const [selectedDevis, setSelectedDevis] = useState(null);
  const [selectedFacture, setSelectedFacture] = useState(null);
  const [selectedDemandePrix, setSelectedDemandePrix] = useState(null);
  const [selectedBonCommande, setSelectedBonCommande] = useState(null);

  const navigate = useNavigate(); // ADD THIS HOOK

  // Dependencies for creation modals
  const [clients, setClients] = useState([]);
  const [fournisseurs, setFournisseurs] = useState([]);
  const [commercials, setCommercials] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [loadingDependencies, setLoadingDependencies] = useState(false);

  const { userData: authUserData } = useContext(AuthContext);
  // --- Load Dependencies for Creation Modals ---
  const loadDependencies = useCallback(async () => {
    setLoadingDependencies(true);
    try {
      // Load clients for devis creation
      const clientsRes = await getAPI('store2000_client', '?limit=100');
      if (clientsRes?.success) {
        setClients(clientsRes.clients || []);
      }

      // Load fournisseurs for demande prix and bon commande creation
      const fournisseursRes = await getAPI('achat', '/fournisseurs?limit=100');
      if (fournisseursRes?.success) {
        setFournisseurs(fournisseursRes.data?.fournisseurs || fournisseursRes.fournisseurs || []);
      }

      // Load commercials for devis creation
      const commercialsRes = await getAPI('employe', '?function=commercial');
      if (Array.isArray(commercialsRes)) {
        setCommercials(commercialsRes);
      }

      // Load companies
      const companiesRes = await getAPI('society', '?limit=100');
      if (companiesRes?.success) {
        setCompanies(companiesRes.data || companiesRes.societies || []);
      }
    } catch (error) {
      console.error('Error loading dependencies:', error);
    } finally {
      setLoadingDependencies(false);
    }
  }, []);

  useEffect(() => {
    if (intervention?._id) {
      loadDependencies();
    }
  }, [intervention?._id, loadDependencies]);

  // --- API Fetch Helpers ---
  const fetchDevis = async (searchTerm = '', signal = null) => {
    try {
      const queryParams = new URLSearchParams({
        limit: '20',
        page: '1',
      });

      if (searchTerm) {
        queryParams.append('search', searchTerm);
      }

      // If we have an intervention client, filter by that client
      if (intervention?.client?.id) {
        queryParams.append('clientId', intervention.client.id);
      }

      const result = await getAPI('devis', `?${queryParams.toString()}`, signal);
      if (result?.success) {
        return result.data?.devis || result.devis || [];
      }
      return [];
    } catch (error) {
      if (error.name !== 'AbortError') console.error('❌ Error fetching devis:', error);
      return [];
    }
  };

  const fetchDemandesPrix = async (searchTerm = '', signal = null) => {
    try {
      const queryParams = new URLSearchParams({
        limit: '20',
        page: '1',
      });

      if (searchTerm) {
        queryParams.append('search', searchTerm);
      }

      // Filter by intervention client if available
      if (intervention?.client?.id) {
        queryParams.append('clientId', intervention.client.id);
      }

      const result = await getAPI('achat', `/demandes-prix/search/recherche?${queryParams.toString()}`, signal);
      return result?.success ? (Array.isArray(result.data) ? result.data : result.data?.demandes || []) : [];
    } catch (error) {
      if (error.name !== 'AbortError') console.error('❌ Error fetching demandes prix:', error);
      return [];
    }
  };

  const fetchBonsCommande = async (searchTerm = '', signal = null) => {
    try {
      const queryParams = new URLSearchParams({
        limit: '20',
        page: '1',
      });

      if (searchTerm) {
        queryParams.append('search', searchTerm);
      }

      // Filter by intervention client if available
      if (intervention?.client?.id) {
        queryParams.append('clientId', intervention.client.id);
      }

      const result = await getAPI('achat', `/bons-commande/bc/recherche?${queryParams.toString()}`, signal);
      return result?.success ? (Array.isArray(result.data) ? result.data : result.data?.bons || []) : [];
    } catch (error) {
      if (error.name !== 'AbortError') console.error('❌ Error fetching bons commande:', error);
      return [];
    }
  };

  const fetchFactures = async (searchItem, signal) => {
    console.log("intervention.client", intervention.client?._id)
    try {
      const filters = {
        and_conditions: [
          { field: 'move_type', operator: '=', value: 'out_invoice' },
          { field: 'partner_id', operator: '=', value: intervention.client._id },

        ],
        or_conditions: [
          { field: 'project_title', operator: 'like', value: searchItem },
          { field: 'name', operator: 'like', value: searchItem },
          { field: 'ref', operator: 'like', value: searchItem },
        ],
      };

      const result = await searchPythonAPI(
        'factures',
        filters,
        1, // pageNum
        50, // perPage
        () => { },
        () => { },
        signal
      );

      // Retourne les données triées pour le dropdown
      return result?.data?.sort((a, b) => b.id - a.id) || [];
    } catch (error) {
      console.error("Erreur fetchFactures:", error);
      return [];
    }
  };

  const [relancesData, setRelancesData] = useState([]); // Initialize as empty array

  const loadChronologieData = useCallback(async () => {
    if (!intervention?._id) return;
    setLoading(true);
    try {
      const chrono = await getChronologieByIntervention(intervention._id);
      setChronologieData(chrono);

      // Fetch the new relances data
       // --- Handlers ---
  const handleAddEntry = async () => {
    if (!newEntry.note.trim()) {
      showNotification('Erreur', 'Veuillez saisir une note', 'warning');
      return;
    }

    setIsSubmitting(true);
    try {
      const userId = userData?._id || userData?.id || authUserData?.id;
      if (!userId) throw new Error('ID utilisateur non trouvé');

      const entryWithUser = { ...newEntry, createdBy: userId };
      await onAddChronologieEntry(intervention._id, entryWithUser);
      if (newEntry.type == CHRONOLOGIE_TYPES.DEVIS && !!newEntry.devisId) {
        await putAPI("devis", { interventionId: intervention._id }, "/" + newEntry.devisId)
      }
      // Reset Form
      setNewEntry({
        type: CHRONOLOGIE_TYPES.NOTE || 'note',
        note: '',
        devisId: '',
        facture: '',
        demandePrixId: '',
        bonCommandeId: '',
        piecesJointes: [],
      });
      setSelectedDevis(null);
      setSelectedDemandePrix(null);
      setSelectedBonCommande(null);
      setSelectedFacture(null);

      await loadChronologieData();
      showNotification('Succès', 'Entrée ajoutée avec succès!', 'success');
    } catch (error) {
      console.error('❌ Error adding entry:', error);
      showNotification('Erreur', 'Erreur ajout: ' + error.message, 'danger');
    } finally {
      setIsSubmitting(false);
    }
  };
    } catch (error) {
      console.error('❌ Error loading data:', error);
      setChronologieData({ entries: [] });
      showNotification('Erreur', 'Erreur lors du chargement des données', 'danger');
    } finally {
      setLoading(false);
    }
  }, [intervention?._id]);

  useEffect(() => {
    if (intervention?._id) {
      loadChronologieData();
    }
  }, [intervention, loadChronologieData]);


  // --- Handlers ---
  const handleAddEntry = async () => {
    if (!newEntry.note.trim()) {
      showNotification('Erreur', 'Veuillez saisir une note', 'warning');
      return;
    }

    setIsSubmitting(true);
    try {
      const userId = userData?._id || userData?.id || authUserData?.id;
      if (!userId) throw new Error('ID utilisateur non trouvé');

      const entryWithUser = { ...newEntry, createdBy: userId };
      await onAddChronologieEntry(intervention._id, entryWithUser);
      if (newEntry.type == CHRONOLOGIE_TYPES.DEVIS && !!newEntry.devisId) {
        await putAPI("devis", { interventionId: intervention._id }, "/" + newEntry.devisId)
      }
      // Reset Form
      setNewEntry({
        type: CHRONOLOGIE_TYPES.NOTE || 'note',
        note: '',
        devisId: '',
        facture: '',
        demandePrixId: '',
        bonCommandeId: '',
        piecesJointes: [],
      });
      setSelectedDevis(null);
      setSelectedDemandePrix(null);
      setSelectedBonCommande(null);
      setSelectedFacture(null);

      await loadChronologieData();
      showNotification('Succès', 'Entrée ajoutée avec succès!', 'success');
    } catch (error) {
      console.error('❌ Error adding entry:', error);
      showNotification('Erreur', 'Erreur ajout: ' + error.message, 'danger');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleTypeChange = (type) => {
    setNewEntry(prev => ({
      ...prev,
      type,
      devisId: '',
      facture: '',
      demandePrixId: '',
      bonCommandeId: ''
    }));
    setSelectedDevis(null);
    setSelectedDemandePrix(null);
    setSelectedBonCommande(null);
  };

  const getUniqueFacturesFromChronologie = useCallback(() => {
    if (!chronologieData?.entries) return [];
    const factureMap = new Map();
    chronologieData.entries.forEach(entry => {
      if (entry.facture && typeof entry.facture === 'string') {
        if (!factureMap.has(entry.facture)) {
          factureMap.set(entry.facture, { id: entry.facture });
        }
      }
    });
    return Array.from(factureMap.values());
  }, [chronologieData]);

  // Determine companyId for RelanceFactureManager
  const companyId = intervention?.company?._id || authUserData?.company?._id || userData?.company?._id;
  const handleDocumentNavigation = (path) => {
    // if (onHide) onHide();
    window.open(path, '_blank'); // Opens in new tab
  };
  const getChronologieTypeLabel = (type) => {
    const labels = {
      note: 'Note',
      devis: 'Devis',
      demande_prix: 'Demande de prix',
      bon_commande: 'Bon de commande',
      appel: 'Appel',
      email: 'Email',
      rappel: 'Rappel',
    };
    return labels[type] || type;
  };

  const formatDate = (date) => !date ? '-' : new Date(date).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  const formatTime = (date) => !date ? '-' : new Date(date).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });

  // Render options for dropdowns
  const renderDevisOption = useCallback((devis) => (
    <div className="small">
      <strong>{devis.reference}</strong> - {devis.clientId?.nom || 'N/A'}
      <div className="text-muted">{devis.totalTTC}€ • {devis.statut}</div>
    </div>
  ), []);

  const renderDemandePrixOption = useCallback((demande) => (
    <div className="small">
      <strong>{demande.reference}</strong>
      <div className="text-muted">{demande.statut} • {new Date(demande.dateCreation).toLocaleDateString()}</div>
    </div>
  ), []);

  const renderBonCommandeOption = useCallback((bon) => (
    <div className="small">
      <strong>{bon.reference || bon.numero}</strong> - {bon.fournisseur?.nom || 'N/A'}
      <div className="text-muted">{bon.totalTTC}€ • {new Date(bon.date).toLocaleDateString()}</div>
    </div>
  ), []);
  const renderFactureOption = (option) => (
    <div className="d-flex justify-content-between align-items-center w-100">
      <div>
        <div className="fw-bold text-dark">{option.name || option.ref}</div>
        <div className="">{option.partner_name}</div>
        <div className="small text-muted">{moment(option.date).format("DD/MM/YYYY")}</div>
      </div>

      <div className="text-end">
        <div className="badge bg-light text-primary border">{formatCurrency(option.amount_total)}</div>
        <div className="smallest text-uppercase text-muted" style={{ fontSize: '10px' }}>{t(option?.state)}</div>
        <div className="smallest text-uppercase text-muted" style={{ fontSize: '10px' }}>{t(option?.payment_state)}</div>
      </div>
    </div>
  );
  // Tracks which entry is currently being edited (null if none)
  const [editingNote, setEditingNote] = useState(null);

  // Tracks the text currently being typed in the edit textarea
  const [editText, setEditText] = useState('');

  /**
   * Initialize editing mode
   */
  const handleEditClick = (entry) => {
    setEditingNote(entry);
    setEditText(entry.note || '');
  };

  /**
   * Handle Update Logic
   */
  const handleSaveEdit = async () => {
    if (!editingNote || !editText.trim()) return;

    try {
      setLoading(true);

      // 1. Prepare payload with updated note
      const entryPayload = { ...editingNote, note: editText };

      // 2. API Call
      const result = await putAPI(
        'planning',
        entryPayload,
        `/chrono/${chronologieData?._id}/entries/${editingNote._id}`
      );

      // 3. Update Local State (Avoid full reload)
      // Assuming chronologieData is your main state object
      if (result) {
        setChronologieData(prev => ({
          ...prev,
          entries: prev.entries.map(entry =>
            entry._id === editingNote._id
              ? { ...entry, note: editText, updatedAt: new Date().toISOString() }
              : entry
          )
        }));

        // Reset editing states
        setEditingNote(null);
        setEditText('');
        // toast.success('Note mise à jour localement');
      }
    } catch (error) {
      console.error("Erreur lors de la mise à jour:", error);
    } finally {
      setLoading(false);
    }
  };

  /**
   * Handle Delete Logic
   */
  const handleDeleteClick = async (entry) => {
    if (!window.confirm("Êtes-vous sûr de vouloir supprimer cet événement ?")) return;

    try {
      setLoading(true);

      // 1. API Call (adjust URL as per your backend)
      await deleteAPI('planning', `/chrono/${chronologieData?._id}/entries/${entry._id}`);

      // 2. Update Local State by filtering out the deleted entry
      setChronologieData(prev => ({
        ...prev,
        entries: prev.entries.filter(e => e._id !== entry._id)
      }));

      // toast.success('Événement supprimé');
    } catch (error) {
      console.error("Erreur lors de la suppression:", error);
    } finally {
      setLoading(false);
    }
  };

  /**
   * Permission Check
   * Logic: User can only edit/delete if they are the creator
   */
  const canEditNote = (entry) => {
    if (!entry || !authUserData) return false;

    // Extract ID depending on if createdBy is an object or a string
    const creatorId = entry.createdBy?._id || entry.createdBy;
    const currentUserId = authUserData._id || authUserData.id;
    return creatorId === currentUserId;
  };
  const handleRelanceQuick = async (devisItem) => {
    // 1. Open browser prompt
    const note = window.prompt(`Ajouter une relance pour ${devisItem.reference}:`, "");

    // 2. Check if user clicked "OK" (note is not null)
    if (note !== null) {
      try {
        setLoading(true);

        // 3. API Call
        await putAPI(
          'devis',
          { remarques: note || "Relance effectuée (sans commentaire)" },
          `/${devisItem.devisId}/relancer`
        );

        // 4. UI Feedback and Refresh
        showNotification('Succès', 'Relance enregistrée avec succès', 'success');

        // Call your existing load function to refresh the list
        if (loadChronologieData) await loadChronologieData();

      } catch (error) {
        console.error("❌ Error saving relance:", error);
        showNotification('Erreur', 'Impossible d\'enregistrer la relance', 'danger');
      } finally {
        setLoading(false);
      }
    }
  };
  const handleEditRelance = async (devisItem, relanceIndex) => {
    const currentRelance = devisItem.historiqueRelances[relanceIndex];

    // 1. Open prompt with the existing text as default
    const newNote = window.prompt(`Modifier la relance #${relanceIndex + 1}:`, currentRelance.remarques);

    // 2. If user didn't click "Cancel" and text is different
    if (newNote !== null && newNote !== currentRelance.remarques) {
      try {
        setLoading(true);

        // Create a copy of the relances array and update the specific index
        const updatedRelances = [...devisItem.historiqueRelances];
        updatedRelances[relanceIndex] = {
          ...currentRelance,
          remarques: newNote,
          updatedAt: new Date(), // Optional: track when it was edited
        };

        // 3. API Call
        await putAPI(
          'devis',
          { relances: updatedRelances },
          `/${devisItem.devisId}`
        );

        showNotification('Succès', 'Remarque mise à jour', 'success');
        if (loadChronologieData) await loadChronologieData();

      } catch (error) {
        console.error("❌ Error updating relance:", error);
        showNotification('Erreur', 'Impossible de modifier la remarque', 'danger');
      } finally {
        setLoading(false);
      }
    }
  };
  const handleDeleteRelance = async (devisItem, relanceIndex) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer cette relance ?")) {
      try {
        setLoading(true);

        // Filter out the relance at the specified index
        const updatedRelances = devisItem.historiqueRelances.filter((_, i) => i !== relanceIndex);

        // Update the Devis with the new array
        await putAPI(
          'devis',
          { relances: updatedRelances },
          `/${devisItem.devisId}`
        );

        showNotification('Succès', 'Relance supprimée', 'success');
        if (loadChronologieData) await loadChronologieData();

      } catch (error) {
        console.error("❌ Error deleting relance:", error);
        showNotification('Erreur', 'Impossible de supprimer la relance', 'danger');
      } finally {
        setLoading(false);
      }
    }
  };
  if (loading) return <div className="text-center py-5"><Spinner animation="border" variant="primary" /></div>;
  return (
    <div className="p-3">
      {/* Header & Refresh */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h5 className="mb-0 fw-bold text-dark">
          <Icon icon='History' size='lg' className='text-primary me-2' />
          Chronologie
        </h5>
      </div>

      {/* Timeline List */}
      <Card className="mb-4 border-0 shadow-sm rounded-4">
        <Card.Header className="bg-white border-bottom pt-3 pb-2">
          <div className="d-flex justify-content-between gap-3 align-items-center">
            <h6 className="mb-0 fw-bold text-muted text-uppercase small ls-1">Historique</h6>
            {chronologieData?.entries && (
              <Badge bg="primary" className="rounded-pill px-2">{chronologieData.entries.length}</Badge>
            )}
          </div>
        </Card.Header>
        <Card.Body className="p-0">
          {chronologieData?.entries && chronologieData.entries.length > 0 ? (
            <ListGroup variant="flush">
              {chronologieData.entries.map((entry, index) => {
                const isEditable = canEditNote(entry);
                const isEditing = editingNote?._id === entry._id;

                return (
                  <ListGroup.Item key={entry._id || index} className="px-4 py-3 border-bottom-0 border-top">
                    <div className="d-flex align-items-start gap-3">

                      {/* Content */}
                      <div className="flex-grow-1">
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <div className="d-flex align-items-center">
                            <span className="text-primary text-capitalize">
                              {getChronologieTypeLabel(entry.type)}
                            </span>
                            <small className='text-muted ms-4'> {moment(entry.createdAt).fromNow()}</small>
                          </div>
                          <span className="text-muted small">
                            <Icon icon='Clock' size='sm' className='me-1' />
                            {formatDate(entry.createdAt)} à {formatTime(entry.createdAt)}
                          </span>
                        </div>

                        {isEditing ? (
                          <div className="my-2">
                            <Form.Control
                              as="textarea"
                              rows={3}
                              value={editText}
                              onChange={(e) => setEditText(e.target.value)}
                              disabled={loading}
                              autoFocus
                              className="mb-2"
                            />
                            <div className="d-flex gap-2">
                              <Button size="sm" onClick={handleSaveEdit} disabled={loading}>
                                {loading ? '...' : 'Enregistrer'}
                              </Button>
                              <Button size="sm" variant="light" onClick={() => setEditingNote(null)}>
                                Annuler
                              </Button>
                            </div>
                          </div>
                        ) : (
                          <div className="text-dark fw-bold mb-2" style={{ whiteSpace: 'pre-wrap' }}>
                            {entry.note || <em>Aucune note</em>}
                          </div>
                        )}
                        {/* Documents Links (Badges) */}
                        <div className="d-flex flex-wrap gap-2">
                          {entry.devis?._id && (
                            <Badge bg="light" text="dark" className="border fw-normal hover-shadow fs-6">
                              Devis: {entry.devis.reference}
                              <Icon size="lg" icon='OpenInNew' className='ms-2 text-primary cursor-pointer' onClick={() => handleDocumentNavigation(`/devis/${entry.devis._id}`)} />
                            </Badge>
                          )}
                          {entry.demande_prix && entry.demande_prix._id && (

                            <Badge bg="light" text="dark" className="border fw-normal hover-shadow fs-6" >

                              DP: {entry.demande_prix.reference}

                              <Icon size={"lg"} icon='OpenInNew' className='ms-2 text-primary me-1 cursor-pointer' onClick={() => handleDocumentNavigation(`/demandes-prix/${entry.demande_prix._id}`)} />



                            </Badge>

                          )}

                          {entry.bon_commande && entry.bon_commande._id && (

                            <Badge bg="light" text="dark" className="border fw-normal  hover-shadow fs-6">

                              BC: {entry.bon_commande.reference || entry.bon_commande.numero}

                              <Icon size={"lg"} icon='OpenInNew' className='ms-2 text-primary me-1 cursor-pointer' onClick={() => handleDocumentNavigation(`/bon_commande/${entry.bon_commande._id}`)} />



                            </Badge>

                          )}

                          {!!entry.facture &&
                            (

                              <Badge bg="light" text="dark" className="border fw-normal  hover-shadow fs-6">

                                Facture

                                <Icon size={"lg"} icon='OpenInNew' className='ms-2 text-primary me-1 cursor-pointer' onClick={() => handleDocumentNavigation(`/factures/${entry.facture}`)} />



                              </Badge>

                            )}
                        </div>

                        <div className="mt-2 d-flex justify-content-between align-items-center">
                          <div className="text-muted small">
                            Par <span className="fw-medium text-dark">{getUserDisplayName(entry.createdBy)}</span>
                          </div>

                          {/* Action Buttons: Visible only if isEditable and not currently editing */}
                          <div className="d-flex justify-content-between align-items-center ">

                            {isEditable && !isEditing && (
                              <div className="btn-group ms-2">
                                <Button className='bg-l25-info' variant="link" onClick={() => handleEditClick(entry)}>
                                  <Icon icon="Edit" />
                                </Button>
                                <Button variant="link" className="text-danger bg-l25-danger" onClick={() => handleDeleteClick(entry)}>
                                  <Icon icon="Delete" />
                                </Button>
                              </div>
                            )}
                          </div>

                        </div>
                        {/* {!!entry?.devis?.relanced && (
                          <div className="mt-4">
                            <h6 className="fw-bold border-bottom pb-2">Historique des relances</h6>

                            <div className="d-flex flex-column gap-2 mt-3">
                              {entry?.devis.relances.map((relance, index) => (
                                <div
                                  key={relance._id || index}
                                  className="p-3 border rounded bg-light shadow-sm"
                                  style={{ borderLeft: '4px solid #0d6efd' }} // Petite barre de couleur pour le style
                                >
                                  <div className="d-flex justify-content-between align-items-start mb-2">
                                    <span className="text-primary">
                                      Relance #{index + 1} - {moment(entry.createdAt).fromNow()}
                                    </span>
                                    <small className="text-muted">
                                      {new Date(relance.dateRelance).toLocaleDateString('fr-FR', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit'
                                      })}
                                    </small>
                                  </div>

                                  <p className="mb-1 text-dark" style={{ whiteSpace: 'pre-wrap' }}>
                                    {relance.remarques}
                                  </p>

                                  <div className="">
                                    <small className="text-muted italic" style={{ fontSize: '0.8rem' }}>
                                      Ajouté par : {relance?.createdBy?.name}
                                    </small>
                                  </div>
                                </div>
                              ))}
                            </div>

                          </div>
                        )} */}
                      </div>
                    </div>
                  </ListGroup.Item>
                );
              })}
            </ListGroup>
          ) : (
            <div className="text-center py-5">
              <Icon icon='InfoCircle' size='lg' className='text-muted mb-2' />
              <p className="text-muted mb-0">Aucun événement enregistré.</p>
            </div>
          )}
        </Card.Body>
      </Card>
      {relancesData.length > 0 &&
        <Card className="mb-4 border-0 shadow-sm rounded-4">
          <Card.Header className="bg-white border-bottom pt-3 pb-2">
            <div className="d-flex justify-content-between gap-3 align-items-center">
              <h6 className="mb-0 fw-bold text-muted text-uppercase small ls-1">
                Historique des Relances Devis
              </h6>
              {relancesData.length > 0 && (
                <span className="text-primary px-2">
                  {relancesData.reduce((acc, curr) => acc + curr.nbRelances, 0)} Relance(s)
                </span>
              )}
            </div>
          </Card.Header>
          <Card.Body className="p-0">
            {relancesData.length > 0 ? (
              <ListGroup variant="flush">
                {relancesData.map((devisItem) => (
                  <ListGroup.Item key={devisItem.devisId} className="px-4 py-4 border-bottom">
                    {/* Quote Header */}
                    <div className="d-flex align-items-center mb-3 justify-content-between">
                      <div className="d-flex align-items-center">
                        <div className="bg-light p-2 rounded me-3">
                          <Icon icon="FileText" className="text-primary" />
                        </div>
                        <div>
                          <h6 className="mb-0 fw-bold">
                            Devis : {devisItem.reference}
                          </h6>
                          <small className="text-muted text-capitalize">Statut: {devisItem.statut}</small>
                        </div>
                      </div>

                      {/* Action Button */}
                      <Button
                        variant="outline-primary"
                        size="sm"
                        className="rounded-pill px-3"
                        onClick={() => handleRelanceQuick(devisItem)}
                      >
                        <Icon icon="Plus" className="me-1" />
                        Relancer
                      </Button>
                    </div>

                    {/* Relances List for this specific Devis */}
                    <div className="ps-4 border-start ms-2">
                      {devisItem.historiqueRelances && devisItem.historiqueRelances.length > 0 ? (
                        <div className="d-flex flex-column gap-3">
                          {devisItem.historiqueRelances.map((relance, index) => (
                            <div
                              key={relance._id || index}
                              className="p-3 border rounded bg-white shadow-sm"
                              style={{ borderLeft: '4px solid #0d6efd' }}
                            >
                              <div className="d-flex justify-content-between align-items-start mb-2">
                                <span className="fw-bold text-info small">
                                  Relance {index + 1} - {moment(relance.dateRelance).fromNow()}
                                </span>
                                <div className="d-flex align-items-center gap-2">
                                  {/* EDIT BUTTON */}
                                  <button
                                    className="btn btn-link p-0 text-muted"
                                    onClick={() => handleEditRelance(devisItem, index)}
                                    title="Modifier la remarque"
                                  >
                                    <Icon icon="PencilSquare" size="xs" />
                                  </button>

                                  <small className="text-muted">
                                    <Icon icon="Clock" size="xs" className="me-1" />
                                    {new Date(relance.dateRelance).toLocaleDateString('fr-FR', {
                                      day: '2-digit', month: '2-digit', year: 'numeric',
                                      hour: '2-digit', minute: '2-digit'
                                    })}
                                  </small>
                                </div>
                              </div>

                              <p className="mb-2 text-dark small" style={{ whiteSpace: 'pre-wrap' }}>
                                {relance.remarques || "Aucune remarque."}
                              </p>

                              <div className="pt-2 border-top d-flex justify-content-between align-items-center">
                                <small className="text-muted italic" style={{ fontSize: '0.75rem' }}>
                                  <Icon icon="Person" className="me-1" />
                                  Par : {relance?.createdBy?.name || 'Inconnu'}

                                  {/* Button Group placed on the right of the name */}

                                </small>
                                <div className="btn-group ms-2">
                                  <Button
                                    variant="link"
                                    className='bg-l25-info'
                                    onClick={() => handleEditRelance(devisItem, index)}
                                  >
                                    <Icon icon="Edit" />
                                  </Button>
                                  <Button
                                    variant="link"
                                    className="text-danger bg-l25-danger "
                                    onClick={() => handleDeleteRelance(devisItem, index)}
                                  >
                                    <Icon icon="Delete" />
                                  </Button>
                                </div>
                                {/* Optional: You can also move the group here if you want it strictly right-aligned */}
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <small className="text-muted italic">Aucune relance effectuée pour ce devis.</small>
                      )}
                    </div>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            ) : (
              <div className="text-center py-5">
                <Icon icon='InfoCircle' size='lg' className='text-muted mb-2' />
                <p className="text-muted mb-0">Aucune relance trouvée pour cette intervention.</p>
              </div>
            )}
          </Card.Body>
        </Card>
      }
      {(() => {
        const facturesList = getUniqueFacturesFromChronologie();
        if (facturesList.length === 0) return null;
        return (
          <Card className="mb-4 border-0 shadow-sm rounded-4">
            <Card.Header className="bg-white border-bottom pt-3 pb-2">
              <div className="d-flex justify-content-between gap-3 align-items-center">
                <h6 className="mb-0 fw-bold text-muted text-uppercase small ls-1">
                  Historique des Relances Factures
                </h6>
                <span className="text-primary px-2">
                  {facturesList.length} Facture(s)
                </span>
              </div>
            </Card.Header>
            <Card.Body className="p-0">
              <ListGroup variant="flush">
                {facturesList.map((facture) => (
                  <ListGroup.Item key={facture.id} className="px-4 py-4 border-bottom">
                    <div className="d-flex align-items-center mb-3 justify-content-between">
                      <div className="d-flex align-items-center">
                        <div className="bg-light p-2 rounded me-3">
                          <Icon icon="Receipt" className="text-primary" />
                        </div>
                        <div>
                          <h6 className="mb-0 fw-bold">
                            Facture ID : {facture.id}
                          </h6>
                          <small className="text-muted">Relances & suivis</small>
                        </div>
                      </div>
                    </div>
                    <div className="ps-4 border-start ms-2">
                      <RelanceFactureManager
                        factureId={facture.id}
                        companyId={companyId}
                      />
                    </div>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </Card.Body>
          </Card>
        );
      })()}
      {/* New Entry Form */}
      <Card className="border-0 shadow-sm rounded-4">
        <Card.Header className="bg-white border-bottom pt-3 pb-2">
          <h6 className="mb-0 fw-bold text-muted text-uppercase small ls-1">Nouvel Événement</h6>
        </Card.Header>
        <Card.Body className="p-4">
          <Form>
            <Row className="g-3">
              <Col xs={12} md={4}>
                <Form.Group>
                  <Form.Label className="small fw-bold text-muted">TYPE</Form.Label>
                  <Form.Select
                    value={newEntry.type}
                    onChange={(e) => handleTypeChange(e.target.value)}
                    className="border-light shadow-sm bg-light"
                  >
                    {Object.entries(CHRONOLOGIE_TYPES).map(([key, value]) => (
                      <option key={value} value={value}>
                        {getChronologieTypeLabel(value)}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              {newEntry.type === 'devis' && (
                <Col xs={12} md={8}>
                  <Form.Group>
                    <Form.Label className="small fw-bold text-muted">DEVIS ASSOCIÉ</Form.Label>
                    <SearchableDropdown
                      value={selectedDevis}
                      onChange={(sel) => {
                        setNewEntry(prev => ({ ...prev, devisId: sel?._id || '' }));
                        setSelectedDevis(sel);
                      }}
                      fetchOptions={fetchDevis}
                      placeholder="Rechercher un devis..."
                      displayField="reference"
                      subField="clientId.nom"
                      renderOption={renderDevisOption}
                      showAddButton={true}
                      addButtonIcon="Add"
                      // NEW: Use newTab instead of modal
                      newTab={true} // This will open new tab instead of modal
                      newTabUrl="/devis/new" // URL to open in new tab
                      className="mb-2"
                      inputClassName="form-control"
                      icon="Search"
                      disabled={loadingDependencies}
                    />
                    {loadingDependencies && (
                      <div className="mt-2">
                        <Spinner animation="border" size="sm" className="me-2" />
                        <small className="text-muted">Chargement des dépendances...</small>
                      </div>
                    )}
                  </Form.Group>
                </Col>
              )}

              {newEntry.type === 'demande_prix' && (
                <Col xs={12} md={8}>
                  <Form.Group>
                    <Form.Label className="small fw-bold text-muted">DEMANDE PRIX ASSOCIÉE</Form.Label>
                    <SearchableDropdown
                      value={selectedDemandePrix}
                      onChange={(sel) => {
                        setNewEntry(prev => ({ ...prev, demandePrixId: sel?._id || '' }));
                        setSelectedDemandePrix(sel);
                      }}
                      fetchOptions={fetchDemandesPrix}
                      placeholder="Rechercher une demande..."
                      displayField="reference"
                      subField="statut"
                      renderOption={renderDemandePrixOption}
                      showAddButton={true}
                      addButtonIcon="Add"
                      // NEW: Use newTab instead of modal
                      newTab={true}
                      newTabUrl="/demandes-prix/new"
                      className="mb-2"
                      inputClassName="form-control"
                      icon="Search"
                      disabled={loadingDependencies}
                    />
                    {loadingDependencies && (
                      <div className="mt-2">
                        <Spinner animation="border" size="sm" className="me-2" />
                        <small className="text-muted">Chargement des dépendances...</small>
                      </div>
                    )}
                  </Form.Group>
                </Col>
              )}

              {newEntry.type === 'bon_commande' && (
                <Col xs={12} md={8}>
                  <Form.Group>
                    <Form.Label className="small fw-bold text-muted">BON DE COMMANDE ASSOCIÉ</Form.Label>
                    <SearchableDropdown
                      value={selectedBonCommande}
                      onChange={(sel) => {
                        setNewEntry(prev => ({ ...prev, bonCommandeId: sel?._id || '' }));
                        setSelectedBonCommande(sel);
                      }}
                      fetchOptions={fetchBonsCommande}
                      placeholder="Rechercher un bon..."
                      displayField="reference"
                      subField="fournisseur.nom"
                      renderOption={renderBonCommandeOption}
                      showAddButton={true}
                      addButtonIcon="Add"
                      // NEW: Use newTab instead of modal
                      newTab={true}
                      newTabUrl="/bon_commande/new/new"
                      className="mb-2"
                      inputClassName="form-control"
                      icon="Search"
                      disabled={loadingDependencies}
                    />
                    {loadingDependencies && (
                      <div className="mt-2">
                        <Spinner animation="border" size="sm" className="me-2" />
                        <small className="text-muted">Chargement des dépendances...</small>
                      </div>
                    )}
                  </Form.Group>
                </Col>
              )}

              {newEntry.type === 'facture' && (
                <Col xs={12} md={8}>
                  <Form.Group>
                    <Form.Label className="small fw-bold text-muted">FACTURE ASSOCIÉE</Form.Label>
                    <SearchableDropdown
                      value={selectedFacture}
                      onChange={(sel) => {
                        setNewEntry(prev => ({ ...prev, facture: sel?.id || '' }));
                        setSelectedFacture(sel);
                      }}
                      fetchOptions={fetchFactures}
                      placeholder="Rechercher une facture (Nom, Réf, Client)..."
                      displayField="partner_name" // Champ principal (ex: INV/2024/001)
                      subField="partner_name"
                      renderOption={renderFactureOption}
                      showAddButton={false}
                      newTab={false}
                      className="mb-2"
                      inputClassName="form-control"
                      icon="Receipt" // Icone facture
                      disabled={loadingDependencies}
                    />
                    {loadingDependencies && (
                      <div className="mt-2">
                        <Spinner animation="border" size="sm" className="me-2" />
                        <small className="text-muted">Chargement des factures...</small>
                      </div>
                    )}
                  </Form.Group>
                </Col>
              )}

              <Col xs={12}>
                <Form.Group>
                  <Form.Label className="small fw-bold text-muted">NOTE / DESCRIPTION</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={newEntry.note}
                    onChange={(e) => setNewEntry(prev => ({ ...prev, note: e.target.value }))}
                    placeholder="Détails de l'événement..."
                    className="border-light shadow-sm bg-light"
                  />
                </Form.Group>
              </Col>

              <Col xs={12} className="text-end">
                <Button
                  variant="primary"
                  onClick={handleAddEntry}
                  disabled={!newEntry.note.trim() || isSubmitting}
                  className="px-4 fw-bold shadow-sm"
                >
                  {isSubmitting ? <Spinner size="sm" className="me-2" /> : <Icon icon='PaperPlane' size='sm' className='me-2' />}
                  Ajouter
                </Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>

      <div>
        <Accordion
          id='historyAccordion'
          activeItemId={false}
          className='px-0 mt-1'
          shadow={'none'}
          color='dark'>
          <AccordionItem
            headerTag='span'
            tag={'section'}
            id='historyItem'
            title={
              <small className='text-muted fw-normal'>
                <Icon icon='InfoOutline' size={'lg'} className='me-2' />
                Historique des modifications
              </small>
            }>

            {/* Sort history: Newest first */}
            {[...(intervention?.history || [])].map((item, index) => (
              <div key={item._id || index} className='p-3 mb-2 bg-l10-dark rounded-2 border-start border-primary border-3'>

                {/* Header: Action and Metadata */}
                <div className='text-muted pb-2 d-flex justify-content-between align-items-start'>
                  <div>
                    <strong className="text-primary text-uppercase small me-2">
                      {item.action.replace('_', ' ')}
                    </strong>
                    <span>par </span>
                    <strong>{item.performedBy?.name || 'Système'}</strong>
                  </div>
                  <small>{moment(item.performedAt).format('DD/MM/YYYY HH:mm')}</small>
                </div>

                {/* 1. Case: Simple Updated Fields (using previousValues/newValues) */}
                {item.action === 'updated' && item.details?.changedFields && (
                  <div className="ps-2 border-start ms-1">
                    {item.details.changedFields.map((field) => (
                      <div key={field} className='small mb-1'>
                        <span className="text-muted text-capitalize">{field} : </span>
                        <span className="text-danger  me-1 small">
                          {JSON.stringify(item.previousValues?.[field])}
                        </span>
                        <Icon icon='ArrowRightAlt' className="mx-1" />
                        <span className="text-success fw-bold">
                          {JSON.stringify(item.newValues?.[field])}
                        </span>
                      </div>
                    ))}
                  </div>
                )}

                {/* 2. Case: Status Changed specifically */}
                {item.action === 'status_changed' && (
                  <div className="ps-2">
                    <Badge color="light" className="me-2">{item.previousValues?.statut}</Badge>
                    <Icon icon='ArrowRightAlt' />
                    <Badge color="primary" className="ms-2">{item.newValues?.statut}</Badge>
                  </div>
                )}

                {/* 3. Case: Notes Added/Updated (Handling Body content) */}
                {(item.action === 'note_added' || item.action === 'note_updated') && item.newValues?.body && (
                  <div
                    className="mt-2 p-2 bg-white rounded border small"
                    dangerouslySetInnerHTML={{ __html: item.newValues.body }}
                  />
                )}

                {/* 4. Case: Creation details */}
                {item.action === 'created' && (
                  <div className='small text-muted ps-2 italic'>
                    Entité créée avec le motif: {item.details?.motif || 'N/A'}
                  </div>
                )}

              </div>
            ))}
          </AccordionItem>
        </Accordion>
      </div>
    </div >
  );
};

export default ChronologieTab;